import type { ProjectSummaryApi, ProjectsSearchParams, SortingOptions } from '../models';

const projects: ProjectSummaryApi[] = [
  {
    approvedBy: 'John Smith',
    description: 'Teradyne Domestic',
    endDate: '2025-01-01T00:00:00.000Z',
    isActive: true,
    isApproved: true,
    projectId: 1,
    projectName: 'MCG Test Project/2134/2020/7',
    startDate: '2025-01-01T00:00:00.000Z',
  },
  {
    approvedBy: 'Jane Doe',
    description: 'Global Logistics Initiative',
    endDate: '2025-06-30T00:00:00.000Z',
    isActive: true,
    isApproved: true,
    projectId: 2,
    projectName: 'MCG Test Project/2134/2020/8',
    startDate: '2025-02-15T00:00:00.000Z',
  },
  {
    approvedBy: 'Robert Johnson',
    description: 'Regional Distribution Network',
    endDate: '2024-12-31T00:00:00.000Z',
    isActive: false,
    isApproved: false,
    projectId: 3,
    projectName: 'MCG Test Project/2134/2020/9',
    startDate: '2024-01-01T00:00:00.000Z',
  },
  {
    approvedBy: 'Sarah Williams',
    description: 'Supply Chain Optimization',
    endDate: '2025-09-15T00:00:00.000Z',
    isActive: true,
    isApproved: false,
    projectId: 4,
    projectName: 'MCG Test Project/2134/2020/10',
    startDate: '2025-03-01T00:00:00.000Z',
  },
  {
    approvedBy: 'Michael Brown',
    description: 'Warehouse Consolidation',
    endDate: '2025-11-30T00:00:00.000Z',
    isActive: true,
    isApproved: true,
    projectId: 5,
    projectName: 'MCG Test Project/2134/2020/11',
    startDate: '2025-04-10T00:00:00.000Z',
  },
];

const MOCK_REPEAT_COUNT = 10;

const mockProjects: ProjectSummaryApi[] = Array.from({ length: MOCK_REPEAT_COUNT }, () => projects)
  .flat()
  .map((project, index) => ({ ...project, projectId: index + 1 }));

export const fetchProjects = (
  { skip = 0, take = mockProjects.length }: ProjectsSearchParams,
  _options: { signal?: AbortController['signal'] } = {},
) =>
  Promise.resolve({
    items: mockProjects.slice(skip, skip + take),
    totalCount: mockProjects.length,
  });

export const fetchSortingOptions = (_options: { signal?: AbortController['signal'] } = {}): Promise<SortingOptions> => {
  return Promise.resolve([
    { id: 'date-newest', label: 'Sort by Date (Newest to Oldest)', value: 'date-newest' },
    { id: 'date-oldest', label: 'Sort by Date (Oldest to Newest)', value: 'date-oldest' },
  ]);
};
